import React from 'react';

function timeAgo(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1)   return 'just now';
  if (mins < 60)  return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24)   return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30)  return `${days}d ago`;
  return new Date(iso).toLocaleDateString();
}

export default function DocumentCard({ doc, onClick, onEdit, onDelete }) {
  return (
    <div className="doc-card" onClick={onClick}>
      <div className="doc-card-title">{doc.title}</div>
      <div className="doc-card-preview">{doc.content}</div>

      {doc.tags?.length > 0 && (
        <div className="tags-row" style={{ marginBottom: '0.75rem' }}>
          {doc.tags.slice(0, 4).map(t => (
            <span key={t} className="tag-badge">{t}</span>
          ))}
          {doc.tags.length > 4 && (
            <span className="tag-badge" style={{ opacity: 0.6 }}>+{doc.tags.length - 4}</span>
          )}
        </div>
      )}

      <div className="doc-card-footer">
        <div className="doc-card-meta">
          👁 {doc.hitCount} · {timeAgo(doc.lastAccessedAt)}
        </div>
        <div className="doc-card-actions">
          <button
            className="btn-icon"
            title="Edit"
            onClick={e => { e.stopPropagation(); onEdit?.(doc); }}
          >✎</button>
          <button
            className="btn-icon danger"
            title="Delete"
            onClick={e => { e.stopPropagation(); onDelete?.(doc); }}
          >🗑</button>
        </div>
      </div>
    </div>
  );
}
